import "./AddFunctionality/AddFunctionalityComponent";
import "./EquipmentFunctionalities.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EquipmentFunctionalitiesComponentController from "./EquipmentFunctionalitiesComponentController";

export default class EquipmentFunctionalitiesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentType: "<",
        };
        this.controller = EquipmentFunctionalitiesComponentController;
        this.templateUrl = "/App/Components/EquipmentType/EquipmentFunctionalities/EquipmentFunctionalities.html";
    }
}

module("mmManagePortal").component("irEquipmentFunctionalitiesList", new EquipmentFunctionalitiesComponent());
